import {
    PROMOCODE_GET_SUCCESS,
    PROMOCODE_GET_FAILURE,
    PROMOCODE_GET_REQUEST
} from "../actions/promoCode";


const setGetPromoCode = (state = { promoCodeData: {} }, action) => {
    switch (action.type) {
        case PROMOCODE_GET_SUCCESS:
            return Object.assign({}, action);
        case PROMOCODE_GET_FAILURE:
            return Object.assign({}, action);
        case PROMOCODE_GET_REQUEST:
            return Object.assign({}, action);
        default:
            return state;
    }
};

export {
    setGetPromoCode,

};